import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { styled, Box } from "@mui/material";

const ButtonContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  justifyContent: "space-between",
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    flexDirection: "column-reverse",
    gap: "15px",
  },
});



export default ButtonContainer;
